import React from "react";
import { Route, Routes } from "react-router-dom";

import { Login } from "../Pages/auth/Login";
import { SignUp } from "../Pages/auth/SignUp";
import { SignUpGoogle } from "../Pages/auth/SignUpGoogle";

export const AuthRouting = () => {
  return (
    <Routes>
      <Route index element={<Login></Login>} />
      <Route path="sign-up" element={<SignUp></SignUp>} />
      <Route path="sign-google" element={<SignUpGoogle></SignUpGoogle>} />
    </Routes>
  );
};
